<template>
  <!--
      	作者：luoyiming
      	时间：2019-06-04
      	描述：插件中心-ICP查询-查询
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
    </div>
    <el-row :gutter="10" style="margin-top: 15px">
      <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2"><div class="grid-content"></div></el-col>
      <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20">
        <el-row :gutter="10">
          <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20">
            <el-input placeholder="请输入域名,例:www.baidu.com" v-model="website" clearable></el-input>
          </el-col>
          <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" style="align-items: center;text-align: center">
            <el-button :disabled="!website" type="primary" icon="el-icon-search" @click="query" :loading="loading">搜索</el-button>
          </el-col>
        </el-row>
        <el-row style="margin-top: 15px">
          <div v-if="tableData.length > 0">
            <el-table :data="tableData" border style="width: 100%" :show-header="false">
              <el-table-column prop="key"></el-table-column>
              <el-table-column prop="value"></el-table-column>
            </el-table>
          </div>
        </el-row>
      </el-col>
      <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2"><div class="grid-content"></div></el-col>
    </el-row>
  </div>
</template>
<script>
  import IcpApi from '@/api/icp.js'
  export default {
    data() {
      return {
        formInline: {},
        tableData: [],
        /*是否加载完成*/
        loading: false,
        website: '',
      };
    },
    created() {
    },
    methods: {
      query() {
        let self = this;
        if (!this.website) {
          this.$notify.error('请填写域名')
          return
        }
        let data = {
          website: this.website
        };
        this.loading = true
        IcpApi.queryICP(data, true)
          .then(data => {
            self.loading = false
            if (data.data.res.code !== 200000) {
              this.$notify.error('查询失败')
              return
            }
            let temp = data.data.res.data.success[0]
            if (!temp) {
              this.$notify.error('未备案或备案缓存没有更新')
              return
            }
            self.tableData = [];
            self.tableData.push({
              key: '主办单位名称',
              value: temp.company
            })
            self.tableData.push({
              key: '主办单位性质',
              value: temp.type
            })
            self.tableData.push({
              key: '网站备案/许可证号',
              value: temp.icp
            })
            self.tableData.push({
              key: '网站名称',
              value: temp.name
            })
            self.tableData.push({
              key: '网站首页网址',
              value: temp.homes
            })
            self.tableData.push({
              key: '网站域名',
              value: temp.domains
            })
            self.tableData.push({
              key: '审核时间',
              value: temp.icp_time
            })
          })
          .catch(error => {
            self.loading = false
          })
      }

    }
  };
</script>

<style>
.grid-content {
  min-height: 36px;
}
.el-input input::-webkit-input-placeholder {
  text-align: center;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/icp/icp/index.vue